export default {
  methods: {
    formatPrice(price, quantity = 1) {
      const finalPrice = parseFloat(price * quantity)
        .toFixed(2)
        .split('.');
      const money = finalPrice[0];
      const cents = finalPrice[1];

      return `
        <span class="symbol">€ </span>
        <span class="left">${money}</span>
        <span class="right">${cents}</span>
      `;
    }
  }
};
